<template>
	<component
		:is="element"
		class="group relative z-50"
	>
		<slot name="trigger"></slot>
		<span
			:class="[
				contentVariantClasses[
					props.variant as keyof typeof contentVariantClasses
				],
				'scale-0 opacity-0 transition-all duration-200',
				'absolute mb-2 rounded-sm p-4 shadow-md',
				'border border-slate-300 bg-slate-100',
				'group-hover:mb-2 group-hover:scale-100 group-hover:p-4 group-hover:opacity-100',
				contentClass,
			]"
		>
			<slot name="content"></slot>
		</span>
		<span
			:class="[
				arrowVariantClasses[props.variant as keyof typeof arrowVariantClasses],
				'absolute h-0 w-0 opacity-0 transition-opacity duration-200',
				'group-hover:h-3 group-hover:w-3 group-hover:opacity-100',
				'rotate-45 transform bg-slate-100',
				'border-t border-l border-slate-300',
			]"
		></span>
	</component>
</template>

<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		element: string
		contentClass?: string
		variant?: 'bottom-right' | 'bottom-left'
	}>(),
	{
		variant: 'bottom-right',
	}
)

const contentVariantClasses = {
	'bottom-right': 'top-[calc(100%+7px)] -right-[32px] origin-top-right',
	'bottom-left': 'top-[calc(100%+7px)] -left-[32px] origin-top-left',
}

const arrowVariantClasses = {
	'bottom-right': 'right-[calc(100%-20px)]',
	'bottom-left': 'left-[calc(100%-20px)]',
}
</script>
